import { networkCall } from "../../../util/network-call/network-call";

export const CmsLayoutLoader = async () => {

    const response = await networkCall('/users/me');

    return { response };

};